<template>
  <div class="vue-page-container vue-page-container--login-register">
    <component
      v-if="subLayoutData"
      :is="getSubLayoutComponent"
      :layoutProps="getSubLayoutProps"
      :subLayoutData="getChildLayoutData"
    >
      <slot></slot>
    </component>
    <slot v-else></slot>
  </div>
</template>

<script>
import BlankLayout from "@/layouts/BlankLayout.vue"
import { mapMutations } from "vuex"
export default {
  props: {
    layoutProps: {
      type: Object,
      default: () => {
        return {}
      },
    },
    subLayoutData: {
      type: Object,
      default: null,
    },
  },
  computed: {
    getSubLayoutComponent () {
      return this.$_.get(this.subLayoutData, "component") || BlankLayout
    },
    getSubLayoutProps () {
      return this.$_.get(this.subLayoutData, "props")
    },
    getChildLayoutData () {
      return this.$_.get(this.subLayoutData, "child")
    },
  },
  methods: {
    ...mapMutations("Util", ["setPageLoading"]),
  },
  mounted () {
    this.setPageLoading(false)
  },
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/layouts/LoginLayout.vue